//
// logColor
//

const logColor = (txt, color = 'red') => {
  const options = (color) ? `color: ${color}` : undefined;
  console.log(`%c${txt}`, options);
};

export default logColor;
